// extracted by mini-css-extract-plugin
module.exports = {"credentials":"styles_credentials__Rni6y","copyright":"styles_copyright__bttRl","social":"styles_social__f4Dhm","socialItem":"styles_socialItem__mR0rW"};